module.exports = __webpack_public_path__ + "static/cynthia-5b8f05d2761b16acc16c0a56d5cadf05.png";